import useSWRMutation from 'swr/mutation';
import baseFetcher from '../../shared/baseFetcher';
import usePrequal from '../../prequal/usePrequal';

const updatePrequalFetcher = (config, { arg }) => baseFetcher({
  ...config,
  method: 'PATCH',
  data: arg,
});

const usePrequalPhonesUpdate = ({ onSuccess }) => {
  const { data: prequal } = usePrequal();
  return useSWRMutation({ url: `/prequals/${prequal.id}/phones` }, updatePrequalFetcher, { onSuccess });
};

export default usePrequalPhonesUpdate;
